import {
    useCreateServiceCodeMutation,
    useGetArchivedPaginatedServiceCodesMutation,
    useGetPaginatedServiceCodesMutation,
    useToggleArchiveServiceCodeMutation,
    useUpdateServiceCodeMutation
} from '@services/member/list/service-codes/service-codes.endpoints';
import { ServiceCode } from '@services/member/list/service-codes/service-codes.types';
import { useState, useMemo, useEffect } from 'react';
import { PaginationMetadata } from '@services/providers/cosem.types';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

export const useServiceCodesPageVM = () => {
    const [totalServiceCodes, setTotalServiceCodes] = useState<number>(0);
    const [isArchived, setIsArchived] = useState<boolean>(false);
    const [needReload, setNeedReload] = useState<boolean>();
    const MySwal = withReactContent(Swal);

    const [
        updateServiceCode,
        {
            isSuccess: isUpdateServiceCodeSuccess
        }
    ] = useUpdateServiceCodeMutation();

    const [
        createServiceCode,
        {
            isSuccess: isCreateServiceCodeSuccess
        }
    ] = useCreateServiceCodeMutation();

    const [
        toggleArchiveServiceCode,
        {
            isSuccess: isToggleArchiveServiceCodeSuccess,
        }
    ] = useToggleArchiveServiceCodeMutation();

    const handleArchiveServiceCodes = async (lines: ServiceCode[], archive: boolean ) => {
        MySwal.fire({
            title:
                lines.length === 1
                    ? archive ? 'Êtes-vous sûr de vouloir archiver ce code service ?' : 'Êtes-vous sûr de vouloir désarchiver ce code service ?'
                    : archive ? 'Êtes-vous sûr de vouloir archiver ces codes services ?' : 'Êtes-vous sûr de vouloir désarchiver ces codes services ?',
            icon: 'warning',
            showCancelButton: true,
            iconColor: '#01539D',
            confirmButtonColor: '#01539D',
            confirmButtonText: archive ? 'Archiver' : 'Désarchiver',
            cancelButtonColor: '#FF5F46',
            cancelButtonText: 'Annuler'
        }).then(async (result) => {
            if (result.isConfirmed) {
                lines.forEach((line) => {
                    toggleArchiveServiceCode({ id: line.id, archived: archive });
                });
            }
        });
    };

    useEffect(() => {
        if(isCreateServiceCodeSuccess || isUpdateServiceCodeSuccess || isToggleArchiveServiceCodeSuccess) {
            setNeedReload((prev) => !prev);
        }
    }, [isCreateServiceCodeSuccess, isUpdateServiceCodeSuccess, isToggleArchiveServiceCodeSuccess]);

    useEffect(() => {
        setTotalServiceCodes(0);
    }, [isArchived]);

    const handleMetadata = (metadata: PaginationMetadata) => {
        if (metadata && metadata.total !== undefined) {
            setTotalServiceCodes(metadata.total);
        }
    };

    const mutationHook = useMemo(() => {
        return isArchived ? useGetArchivedPaginatedServiceCodesMutation : useGetPaginatedServiceCodesMutation;
    }, [isArchived]);

    return {
        mutationHook,
        totalServiceCodes,
        setTotalServiceCodes,
        isArchived,
        handleMetadata,
        needReload,
        setIsArchived,
        createServiceCode,
        updateServiceCode,
        handleArchiveServiceCodes,
        MySwal
    };
};
